import React, { FC } from "react";

const ImageUnavailable: FC = () => {
  return <div className="image-unvailable">Image Unavailable</div>;
};
export { ImageUnavailable };
